import getWidthAndHeightOfImageUrl from './getWidthAndHeightOfImageUrl';

const getWidthAndHeightOfImageFile = async file => {
  const imageUrl = URL.createObjectURL(file.file);

  return getWidthAndHeightOfImageUrl(imageUrl);
};

export default getWidthAndHeightOfImageFile;
